export default "__VITE_ASSET__CpVG63dr__"